module.exports = __webpack_public_path__ + "img/sol light.22a6d60c.svg";